import script from "./AnnualReviewTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnnualReviewTab.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/loans/form.css?vue&type=style&index=0&id=581a2f30&scoped=true&lang=css&external"
import "./AnnualReviewTab.vue?vue&type=style&index=1&id=581a2f30&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-581a2f30"]])

export default __exports__